module.exports = __webpack_public_path__ + "img/recursos-humanos.80ca9e36.jpg";